'use client';

import { AnimatedSticker } from '../animated-sticker';
import { Button } from '../ui';

interface TransactionStatusDisplayProps {
  title: string;
  message: string;
  stickerSrc: string;
  buttonText?: string;
  onButtonClick?: () => void;
}

export const TransactionStatusDisplay = ({
  title,
  message,
  stickerSrc,
  buttonText,
  onButtonClick,
}: TransactionStatusDisplayProps) => (
  <div className="mt-6 h-[80vh] relative grid grid-rows-[1fr_min-content]">
    <div className="flex flex-col items-center justify-center text-center space-y-4">
      <div className="text-6xl mb-10">
        <div className="size-[180px]">
          <AnimatedSticker autoplay loop src={stickerSrc} />
        </div>
      </div>
      <h3 className="text-[32px] font-bold ">{title}</h3>
      <p className="text-white/60 font-bold text-[16px]">{message}</p>
    </div>
    {buttonText && onButtonClick ? (
      <Button className="w-full mb-6" variant="rainbow" onClick={onButtonClick}>
        {buttonText}
      </Button>
    ) : null}
  </div>
);
